const axios = require('axios'),
  moment = require('moment')

const getTeamDetails = team_id => {
  return axios
    .get('https://backend.sofive.com/team/' + team_id)
    .then(resp => resp.data)
}

const getLeagueDetails = league_id => {
  return axios
    .get(`https://backend.sofive.com/league/${league_id}/scores`)
    .then(resp => resp.data)
}

export const getMatchDetails = match_id => {
  console.log('Getting details', match_id)
  return axios
    .get('https://backend.sofive.com/match/' + match_id)
    .then(resp => {
      return getTeamDetails(resp.data.home.team_id).then(home_team => {
        return getTeamDetails(resp.data.away.team_id).then(away_team => {
          const league_id = home_team.league.id
          return getLeagueDetails(league_id).then(league => {
            let start = league.matches.find(m => m.id === match_id.toString())
            if (start) {
              start = moment(start.start, 'YYYY-MM-DDTHH:mm:ss').format('h:mmA')
            }
            let description = "Upcoming match"
            if (resp.data.match_type === "playoff") {
              const spl = resp.data.description.split(":")
              if (spl.length > 1) {
                description = spl[0]
              }
            }
            return {
              home: {
                name: home_team.name,
              },
              away: {
                name: away_team.name,
              },
              start,
              league: league.name,
              standings: league.leaderboard.map(s => ({
                team: s.Team,
                points: s.Points,
                gf: s.GF,
                gd: (s.GD >= 0 ? '+' : '') + s.GD.toString(),
                home: s.id === resp.data.home.team_id,
                away: s.id === resp.data.away.team_id,
              })),
              description
            }
          })
        })
      })
    })
}
